import TestimonialOverview from '../implementations/Views/Testimonial/Overview';
import TestimonialFrontPage from '../implementations/Views/Testimonial/FrontPage';
import TestimonialSidebar from '../implementations/Views/Testimonial/Sidebar';
import NewsOverview from '../implementations/Views/News/Overview';
import MunicipalityOverview from '../implementations/Views/Municipality/Overview';

const mappers = {
  views_block__testimonial_block_1: TestimonialOverview,
  views_block__testimonial_block_2: TestimonialFrontPage,
  views_block__testimonial_block_3: TestimonialSidebar,
  views_block__news_block_1: NewsOverview,
  views_block__municipality_block_1: MunicipalityOverview,
};

export default mappers;
